import { render, staticRenderFns } from "./ProjRep.vue?vue&type=template&id=24cc715c"
import script from "./ProjRep.vue?vue&type=script&lang=js"
export * from "./ProjRep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports